<!-- https://8es9hr.axshare.com/#p=%E8%87%A8%E6%AB%83%E4%BD%9C%E6%A5%AD%E9%A6%96%E9%A0%81_%E7%A4%BE%E5%93%A1%E6%90%9C%E5%B0%8B&g=1 -->
<!-- 臨櫃作業首頁_社員搜尋 -->
<template>
    <div class="row">
        <div class="col-12">
            <div
                class="status"
                :class="{'text-danger':getstatusCode.statuCode !== '1'}"
                v-if="getstatusCode.statuCode !=='1'"
            >{{getstatusCode.statusTitle + "，無法開立傳票"}}</div>
            <div class="col-block">
                <div class="block-header has-border">
                    <el-input
                        placeholder="請輸入社員帳號、姓名、或證件號"
                        v-model="keyword"
                        @keyup.native.enter="getMember"
                    >
                        <el-button slot="append" icon="el-icon-search" @click="getMember"></el-button>
                    </el-input>
                    <div class="search-hint">
                        <div class="search-hint-title">搜尋提示</div>
                        <p>支援以會員帳號、姓名或身份證字號搜尋。</p>
                        <p>為提升查詢效率，搜尋結果僅顯示前 10 筆；若符合資料超過 10 筆，請輸入更精確的關鍵字。</p>
                    </div>
                </div>
                <div id="search-loading" class="block-content">
                    <el-card class="box-card" v-for="member of memberOptions" :key="member.id">
                        <el-button type="primary" @click="go(member.id)">選擇</el-button>
                        {{ member.account }} {{ member.name }} {{ member.nameExtNoteDisplay==1 ? member.nameExtNote : '' }} {{ member.idNumber ? member.idNumber : '' }}
                        <div class="clear"></div>
                    </el-card>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { API } from "@/assets/config";
import debounce from "lodash/debounce";

export default {
    name: "cabinet_search",
    data() {
        return {
            keyword: "",
            memberOptions: [],
            getstatusCode: {
                statuCode: "",
                statusTitle: ""
            }
        };
    },
    methods: {
        go(id) {
            this.$router.push({ name: "cabinet_edit", params: { id: id } });
        },
        getMember: debounce(function() {
            const vm = this;
            /*   let url = API.member;
            console.log(debounce);
            this.$http.get(url).then(response => {
                vm.memberOptions = response.data.resultData.data;
            }); */
            const queryObj = {
                filter: {
                    cabinetSearch: "1"
                },
                search: this.keyword
            };
            const loading = this.$loading({
                target: "#search-loading",
                text: "讀取中",
                spinner: "el-icon-loading"
            });
            const url = API.member + `?where=${JSON.stringify(queryObj)}`;
            const thenCB = json => {
                this.memberOptions = json.resultData.data;
                loading.close();
            };
            this.mAxiosGet(url, thenCB);
        }, 300),
        getStatus() {
            //讀取日結狀態的狀態碼與標頭，把參數帶上去去判斷是否顯示
            let url = API.counterWork + `?action=getSettlementStatus`;
            this.$http(url).then(response => {
                if (response.data.resultData.status === 1) {
                    this.getstatusCode.statuCode = "1";
                    this.getstatusCode.statusTitle = "未關帳";
                } else if (response.data.resultData.status === 2) {
                    this.getstatusCode.statuCode = "2";
                    this.getstatusCode.statusTitle = "關帳中";
                } else if (response.data.resultData.status === 3) {
                    this.getstatusCode.statuCode = "3";
                    this.getstatusCode.statusTitle = "已關帳";
                } else if (response.data.resultData.status === 4) {
                    this.getstatusCode.statuCode = "4";
                    this.getstatusCode.statusTitle = "前一作業日未關帳";
                }
            });
        }
    },
    created() {
        this.getStatus();
    }
};
</script>
<style lang="scss" scoped>
#search-loading {
    min-height: 80px;
}

.block-content {
    .box-card {
        font-size: 18px;
        line-height: 40px;
        margin-top: 10px;
        button {
            margin-right: 20px;
        }
    }
}

.status {
    font-size: 20px;
    font-weight: 700;
}

.search-hint {
    margin-top: 12px;
    color: #6D4C41;
    font-size: 17px;
    font-weight: 400;
    line-height: 1.4;

    .search-hint-title {
        color: #F57C00;
        font-size: 20px;
        font-weight: 700;
        margin-bottom: 2px;
    }

    p {
        margin: 0;
    }
}
</style>